import React from 'react';
import PropTypes from 'prop-types';
import * as Api from 'api';
import { connect } from 'react-redux';
import * as Actions from 'actions';
class ClientsDownload extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    generating: false,
    url: ''
  }
  render() {
    const {generating, url} = this.state;
    const {selected_filters, sort_column, bounds, downloaded_maps} = this.props;
    const maps = (downloaded_maps || []).map(({map}) => map._id);
    const button_class_name = this.props.custom_button_class_name || `btn btn-info${ this.props.className? ' ' + this.props.className : ''}`
    return (
      <span className="">
        <span onClick={!generating ? (f => {
          this.setState(
            {generating: true},
            f => Api.generateClientsReportWithFilters({filters: selected_filters, sort_column, bounds, maps})
              .then(({file}) => {
                this.setState({url: file.url, generating: false})
              })
              .catch(e => this.setState({generating: false}, f => this.props.notify(e)))
            );
          }) : (f => {})} className={button_class_name}
          >
          {generating ? (
            <span>
              <i className="fa fa-spin fa-spinner"></i> Generating
            </span>
          ) : (
            <span>
              <i className="fa fa-cloud-download"></i> Impact Report
            </span>
          )}
        </span>
        {url ?
          <a href={url} target='_blank' className="btn btn-success">
            <i className='fa fa-download'></i>
          </a>
        : ''}
      </span>
    );
  }
}

export default connect(({clients, map_search}) => ({...clients, downloaded_maps: map_search.downloaded_maps}), Actions)(ClientsDownload);



// WEBPACK FOOTER //
// ./src/browser/components/clients/clients-download.js